type AmplifyOutputs = {
  default?: {
    auth: {
      user_pool_id: string;
      user_pool_client_id: string;
      aws_region: string;
      identity_pool_id: string;
    };
    data: {
      url: string;
      aws_region: string;
      default_authorization_type: string;
    };
    custom?: {
      // VPC Configuration (optional - only in production with VPC)
      vpcId?: string;
      privateSubnetIds?: string[];
      publicSubnetIds?: string[];
      securityGroupId?: string;

      // Registration Lambda Functions
      postRegistrationFunctionName?: string;
      postRegistrationFunctionArn?: string;
      getRegistrationFunctionName?: string;
      getRegistrationFunctionArn?: string;

      // ICAPI Lambda Functions
      getByIdFunctionName?: string;
      getByIdFunctionArn?: string;
      updateEmailFunctionName?: string;
      updateEmailFunctionArn?: string;
      updatePhoneFunctionName?: string;
      updatePhoneFunctionArn?: string;
      updateNameFunctionName?: string;
      updateNameFunctionArn?: string;
      updateAddressFunctionName?: string;
      updateAddressFunctionArn?: string;
      billSearchFunctionName?: string;
      billSearchFunctionArn?: string;
      billQueryFunctionName?: string;
      billQueryFunctionArn?: string;

      // DynamoDB Tables
      registrationTableName?: string;
      registrationTableArn?: string;

      // Unified API Gateway
      apiGatewayId?: string;
      apiGatewayUrl?: string;
      apiGatewayStage?: string;

      // Custom Domain Configuration
      customDomainUrl?: string;
      customDomainEnabled?: boolean;

      // V2 API Gateway
      v2ApiGatewayId?: string;
      v2ApiGatewayUrl?: string;
      v2ApiGatewayStage?: string;

      // V2 Account Endpoints
      v2QueryAccountUrl?: string;
      v2GetAccountBalanceUrl?: string;
      v2ListAccountServicesUrl?: string;
      v2UpdateCustomerContactUrl?: string;

      // ICAPI Endpoints
      getAccountByIdUrl?: string;
      updateEmailUrl?: string;
      updatePhoneUrl?: string;
      updateNameUrl?: string;
      updateAddressUrl?: string;
      billSearchUrl?: string;
      billQueryUrl?: string;

      // Registration Endpoints
      registerUrl?: string;

      // API Keys
      portalFrontendApiKeyId?: string;
      atlasDigitalApiKeyId?: string;
      portalFrontendApiKey?: string; // Actual API key value

      // Environment Information
      environment?: string;
      branchName?: string;
      appId?: string;
      stackSuffix?: string;
    }
  }
}

export async function resolveOutputsFile() {
  let outputsFile: AmplifyOutputs;

  try {
    // First try from app directory (where amplify.yml copies it)
    outputsFile = await import('./amplify_outputs.json') as AmplifyOutputs;
  } catch {
    try {
      // Try from root directory
      outputsFile = await import('@/amplify_outputs.json') as AmplifyOutputs;
    } catch {
      try {
        // Try relative from components directory to root
        outputsFile = await import('../../amplify_outputs.json') as AmplifyOutputs;
      } catch {
        try {
          // Try the default location where ampx generates it, this is the location of the amplify_outputs.json file
          outputsFile = await import('../amplify_outputs.json') as AmplifyOutputs;
        } catch {
          throw new Error('No outputs file found');
        }
      }
    }
  }
  return outputsFile;
}
